import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() opened: boolean;
  appVersion: string = '1.1.9';
  apiVersion: string = '1.1.9';
  constructor() {}

  ngOnInit(): void {}
}
